export default {
    name: "image-placeholder",
    components: {},
    props: ["source"],
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
